import { HardBreak } from './hard-break.js'

export * from './hard-break.js'

export default HardBreak
